import { 
  deleteSupplierBankCard, 
  getSpecifiedLevelTree, 
  reqSupplierAccountList, 
  saveSupplierBankCard,
  fetchAccountDetail,
  reqSupplierAccountListNew,
} from '../services/service';

export default {
  namespace: 'supplierInfo',
  state: {
    pagination: {
      total: 0, 
      current: 1, 
      pageSize: 10,
    },
    supplierList: [],
    cityList: [],
    accountDetail: {},
    supplierAccountList: [],
  },
  effects: {
    // 获取供应商列表
    * getList ({ payload }, { call, put }) {
      const res = yield call(reqSupplierAccountList, payload);
      const { result = {} } = res;
      const { data, pageNum, pageSize, total } = result || {};
      yield put({
        type: 'update',
        payload: {
          supplierList: data || [],
          pagination: {
            current: pageNum,
            pageSize,
            total,
          },
        },
      });
      return res;
    },
    // 删除供应商信息
    * delete ({ payload }, { call }) {
      const { accountCode } = payload;
      const res = yield call(deleteSupplierBankCard, accountCode);
      return res;
    },
    // 保存供应商信息
    * saveSupplier ({ payload }, { call }) {
      const res = yield call(saveSupplierBankCard, payload); 
      return res;
    },
    // 获取开户城市列表
    * getSpecifiedLevelTree ({ payload }, { call, put }) {
      const res = yield call(getSpecifiedLevelTree, payload);
      yield put({
        type: 'update',
        payload: {
          cityList: res.result,
        },
      });
    },
    // 获取银行卡详情
    * fetchAccountDetail ({ payload }, { call, put }) {
      const { accountCode } = payload;
      const res = yield call(fetchAccountDetail, accountCode);
      return res;
    },
    // 获取供应商列表-一般事项新接口
    * getSupplierAccountList ({ payload }, { call, put }) {
      const res = yield call(reqSupplierAccountListNew, payload);
      const { result = [] } = res;
      yield put({
        type: 'update',
        payload: {
          supplierAccountList: result || [],
        },
      });
      return res;
    },
  },
  reducers: {
    update (state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};
